import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { XCircleIcon } from '@phosphor-icons/react';

export const Route = createFileRoute('/_auth/_side-layout/payments/cancel')({
  component: PaymentsCancel,
});

function PaymentsCancel() {
  return (
    <main className="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <h1 className="flex items-center justify-center gap-2 text-2xl font-bold tracking-tight sm:text-3xl">
          <XCircleIcon
            size={32}
            weight="regular"
            className="text-destructive"
          />
          Payment Cancelled
        </h1>
        <p className="text-muted-foreground mt-6 text-base leading-7">
          Your payment was not processed. You can try again anytime.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link to="/">
            <Button>Go to Dashboard</Button>
          </Link>
          <Link to="/settings/billing" className="font-semibold">
            View Billing <span aria-hidden="true">&rarr;</span>
          </Link>
        </div>
      </div>
    </main>
  );
}
